/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefit_PlacementInputs */

const en_directory_promotion_benefit_placement = /** @type {(inputs: Directory_Promotion_Benefit_PlacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eligible published tools receive labeled sponsor placement in the directory.`)
};

const zh_directory_promotion_benefit_placement = /** @type {(inputs: Directory_Promotion_Benefit_PlacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核发布后的产品可获得带明确标识的目录赞助展示。`)
};

/**
* | output |
* | --- |
* | "Eligible published tools receive labeled sponsor placement in the directory." |
*
* @param {Directory_Promotion_Benefit_PlacementInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefit_placement = /** @type {((inputs?: Directory_Promotion_Benefit_PlacementInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefit_PlacementInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefit_placement(inputs)
	return zh_directory_promotion_benefit_placement(inputs)
});
export { directory_promotion_benefit_placement as "directory.promotion.benefit_placement" }